import { createIntent, type WebViewIntent } from '@/lib/react-native/services/react-native.intent'

export function createOpenExternalWebUrlIntent(url: string): WebViewIntent {
  return createIntent('OPEN_EXTERNAL_WEB_URL', { url })
}

export const withEmbedInPath = (rawUrl: string): string => {
  const url = new URL(rawUrl)

  if (!url.pathname.startsWith('/embed')) {
    const path = url.pathname === '/' ? '' : url.pathname
    url.pathname = '/embed' + path
  }

  return url.toString()
}
